// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Sede_container_sede__cYgEj {
  width: 80%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  font-family: Arial, sans-serif;
  margin: 0 auto;

  }
  
  .Sede_container_sede__cYgEj h1 {
    font-size: 36px;
    color: #4a4a4a;
    margin-bottom: 20px;
    margin-top: 1em;
 margin-bottom: 1em;
  }
  .Sede_hr__qQwkX {
    border-bottom: 1px solid #cfd8dc;

  }
 
  .Sede_locations_list__2j7cN {
    display: flex;
    flex-direction: column;
  }
  
  .Sede_location_card__POktE {
    display: flex;
    align-items: center;
    border-bottom: 1px solid #cfd8dc;
    padding: 20px 0;
  }
  .Sede_link__XwGzs {
    color: #8ca7a6;
    text-decoration: underline;
    cursor: pointer;
    font-size: 14px;
  }
  .Sede_location_image__5k\\+AR {
    width: 100px;
    height: 100px;
    border-radius: 10px;
    object-fit: cover;
  }
  
  .Sede_location_info__HOoSl {
    margin-left: 20px;
    text-align: left;
  }
  
  .Sede_location_info__HOoSl h2 {
    font-size: 18px;
    color: #4a4a4a;
    margin: 0;
  }
  
  .Sede_location_info__HOoSl p {
    font-size: 14px;
    color: #7b7b7b;
    margin: 5px 0;
    font-weight: bold;
  }
  
  /* src/components/Profile.module.css */

.Sede_profile__E3jf9 {
  text-align: center;
  background-color: #ffffff;
  border-radius: 12px;
  margin: 40px auto;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}



.Sede_profileImage__w9\\+am {
  width: 200px;
  height: 200px;

  margin-bottom: 15px;
  border: 4px solid #f0f0f0;
  transition: border-color 0.3s;
}



.Sede_name__RS\\+Gn {
  font-size: 1.8em;
  margin: 10px 0;
  color: #333;
  font-weight: 600;
  letter-spacing: 0.5px;
}
.Sede_specialty__HgKPl {
  font-size: 1.4em;
  margin: 10px 0;
  color: #333;
  font-weight: 600;
  letter-spacing: 0.5px;
}
@media screen and (max-width: 768px) {
  .Sede_name__RS\\+Gn {
    font-size: 1.2em;
    margin: 10px 0;
    color: #333;
    font-weight: 600;
    letter-spacing: 0.5px;
    text-align: center;
  }
  .Sede_profile__E3jf9 {
    text-align: start;
    background-color: #ffffff;
    border-radius: 12px;
    margin: 40px auto;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
  }
  .Sede_specialty__HgKPl {
    text-align: center;
  }

  .Sede_container_sede__cYgEj h1 {
    font-size: 23px;
    color: #4a4a4a;
    margin-bottom: 20px;
    margin-top: 1em;
 margin-bottom: 1em;
  }
}

.Sede_description__MEHba {
  font-size: 1em;
  color: #666;
  margin: 10px 0 20px;
  line-height: 1.6;
  padding: 0 15px;
}

.Sede_socialLinks__KcQ7v {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-bottom: 20px;
}

.Sede_socialLink__NqEkx {
  color: #0077b5;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.3s, transform 0.3s;
}

.Sede_socialLink__NqEkx:hover {
  color: #005582;
  transform: scale(1.1);
}

.Sede_address__\\+GT8r {
  font-size: 0.9em;
  color: #888;
  line-height: 1.5;
}

  
  `, "",{"version":3,"sources":["webpack://./src/styles/Home/Sede.module.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;EAClB,8BAA8B;EAC9B,cAAc;;EAEd;;EAEA;IACE,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,eAAe;CAClB,kBAAkB;EACjB;EACA;IACE,gCAAgC;;EAElC;;EAEA;IACE,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,gCAAgC;IAChC,eAAe;EACjB;EACA;IACE,cAAc;IACd,0BAA0B;IAC1B,eAAe;IACf,eAAe;EACjB;EACA;IACE,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,SAAS;EACX;;EAEA;IACE,eAAe;IACf,cAAc;IACd,aAAa;IACb,iBAAiB;EACnB;;EAEA,sCAAsC;;AAExC;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,qDAAqD;AACvD;;;;AAIA;EACE,YAAY;EACZ,aAAa;;EAEb,mBAAmB;EACnB,yBAAyB;EACzB,6BAA6B;AAC/B;;;;AAIA;EACE,gBAAgB;EAChB,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE;IACE,gBAAgB;IAChB,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,qBAAqB;IACrB,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,iBAAiB;IACjB,qDAAqD;EACvD;EACA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,eAAe;CAClB,kBAAkB;EACjB;AACF;;AAEA;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB","sourcesContent":[".container_sede {\n  width: 80%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  text-align: center;\n  font-family: Arial, sans-serif;\n  margin: 0 auto;\n\n  }\n  \n  .container_sede h1 {\n    font-size: 36px;\n    color: #4a4a4a;\n    margin-bottom: 20px;\n    margin-top: 1em;\n margin-bottom: 1em;\n  }\n  .hr {\n    border-bottom: 1px solid #cfd8dc;\n\n  }\n \n  .locations_list {\n    display: flex;\n    flex-direction: column;\n  }\n  \n  .location_card {\n    display: flex;\n    align-items: center;\n    border-bottom: 1px solid #cfd8dc;\n    padding: 20px 0;\n  }\n  .link {\n    color: #8ca7a6;\n    text-decoration: underline;\n    cursor: pointer;\n    font-size: 14px;\n  }\n  .location_image {\n    width: 100px;\n    height: 100px;\n    border-radius: 10px;\n    object-fit: cover;\n  }\n  \n  .location_info {\n    margin-left: 20px;\n    text-align: left;\n  }\n  \n  .location_info h2 {\n    font-size: 18px;\n    color: #4a4a4a;\n    margin: 0;\n  }\n  \n  .location_info p {\n    font-size: 14px;\n    color: #7b7b7b;\n    margin: 5px 0;\n    font-weight: bold;\n  }\n  \n  /* src/components/Profile.module.css */\n\n.profile {\n  text-align: center;\n  background-color: #ffffff;\n  border-radius: 12px;\n  margin: 40px auto;\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n}\n\n\n\n.profileImage {\n  width: 200px;\n  height: 200px;\n\n  margin-bottom: 15px;\n  border: 4px solid #f0f0f0;\n  transition: border-color 0.3s;\n}\n\n\n\n.name {\n  font-size: 1.8em;\n  margin: 10px 0;\n  color: #333;\n  font-weight: 600;\n  letter-spacing: 0.5px;\n}\n.specialty {\n  font-size: 1.4em;\n  margin: 10px 0;\n  color: #333;\n  font-weight: 600;\n  letter-spacing: 0.5px;\n}\n@media screen and (max-width: 768px) {\n  .name {\n    font-size: 1.2em;\n    margin: 10px 0;\n    color: #333;\n    font-weight: 600;\n    letter-spacing: 0.5px;\n    text-align: center;\n  }\n  .profile {\n    text-align: start;\n    background-color: #ffffff;\n    border-radius: 12px;\n    margin: 40px auto;\n    transition: transform 0.3s ease, box-shadow 0.3s ease;\n  }\n  .specialty {\n    text-align: center;\n  }\n\n  .container_sede h1 {\n    font-size: 23px;\n    color: #4a4a4a;\n    margin-bottom: 20px;\n    margin-top: 1em;\n margin-bottom: 1em;\n  }\n}\n\n.description {\n  font-size: 1em;\n  color: #666;\n  margin: 10px 0 20px;\n  line-height: 1.6;\n  padding: 0 15px;\n}\n\n.socialLinks {\n  display: flex;\n  justify-content: center;\n  gap: 20px;\n  margin-bottom: 20px;\n}\n\n.socialLink {\n  color: #0077b5;\n  text-decoration: none;\n  font-weight: 500;\n  transition: color 0.3s, transform 0.3s;\n}\n\n.socialLink:hover {\n  color: #005582;\n  transform: scale(1.1);\n}\n\n.address {\n  font-size: 0.9em;\n  color: #888;\n  line-height: 1.5;\n}\n\n  \n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container_sede": `Sede_container_sede__cYgEj`,
	"hr": `Sede_hr__qQwkX`,
	"locations_list": `Sede_locations_list__2j7cN`,
	"location_card": `Sede_location_card__POktE`,
	"link": `Sede_link__XwGzs`,
	"location_image": `Sede_location_image__5k+AR`,
	"location_info": `Sede_location_info__HOoSl`,
	"profile": `Sede_profile__E3jf9`,
	"profileImage": `Sede_profileImage__w9+am`,
	"name": `Sede_name__RS+Gn`,
	"specialty": `Sede_specialty__HgKPl`,
	"description": `Sede_description__MEHba`,
	"socialLinks": `Sede_socialLinks__KcQ7v`,
	"socialLink": `Sede_socialLink__NqEkx`,
	"address": `Sede_address__+GT8r`
};
export default ___CSS_LOADER_EXPORT___;
